import { FindQRequest, IProduct } from './../Model/Questionnaire'
import {
    UpdatePaymentStatusRequest,
    getPaymentStatusText,
    PaymentStatus,
    PaymentSource,
    PaymentType,
    PaymentDirection
} from './../Model/Payment'
import { Merchant } from './../Model/MerchantModel'
import { Affiliate } from './../Model/AffiliateModel'
import { observable, action } from 'mobx'
import RequestExecutorHelper from '../Helpers/RequestExecutorHelper'
import * as axios from 'axios'
import NotificationsStore, { NotificationEntity, INotificationEntity } from '../Stores/NotificationsStore'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import UsersStore from '../Stores/UsersStore'
import UserStore from '../Stores/UserStore'
import EventsStore from '../Stores/EventsStore'
import { Nav } from '../Model/Nav'
import LocalizationService from '../Stores/LocalizationStore'
import { history } from '../Routing'
import { QuestionnaireStatus, PaginationRequest } from '../Model/Questionnaire'
import AuthService from './AuthService'
import { TroubleEventStatus } from '../Model/TroubleEvent'
import PaymentsStore from '../Stores/PaymentsStore'
import { DownloadDocumentType } from '../Model/DownloadDocumentType'
import ExternalDataStore from '../Stores/ExternalDataStore'
import ReportsService from './ReportsService'
import { ExternalGovPhoneData, ExternalGovPinData } from '../Model/ExternalData'
import { ExternalDataSourceType } from '../Model/PaymentPrefillForm'
import SettingsStore from '../Stores/SettingsStore'
import Setting from '../Model/Setting'
import { CreatePaymentRequest, CreatePaymentQuestionnaireModel } from '../Model/Payment'
import * as _ from 'lodash'
import MerchantsStore from '../Stores/MerchantsStore'
import AffiliatesStore from '../Stores/AffiliatesStore'
// import { PaymentScheduleItemModel } from '../Model/PaymentScheduleItemModel'
import CatalogProductsStore from '../Stores/CatalogProductsStore'
import CatalogProduct from '../Model/CatalogProduct'
import { QuestionnairePrefillData } from '../Model/Questionnaire'
import CreditsStore from '../Stores/CreditsStore'
import { ICreditCondition } from '../Model/CreditCondition'
import { CancelReason } from '../Model/CancelReasonModel'
import { IAgentInfo } from '../Model/AgentInfo'
import { CourtDecision } from '../Model/CourtDecision'
import { MobileIMEIRequest } from '../Model/MobileIMEI'
import ScheduleConfigurationStore from '../Stores/ScheduleConfigurationStore'
import { ScheduleConfig } from '../Model/ScheduleConfig'
// const moment = require('moment')

export default class HttpActionsService {
    private openIdScope = ['openid', 'email', 'phone', 'profile', 'offline_access', 'roles'].join(' ')

    private apiCCHost: string = 'https://srscore.net:8080'
    private apiCCHttpsHost: string = 'https://srscore.net:8080'
    private apiCCExternalHttpHost: string = 'https://srscore.net:8888'
    // private apiCCHost: string = 'http://localhost:52145'
    // private apiCCHttpsHost: string = 'http://localhost:52145/'

    private user = UserStore.getInstance()
    private notificationsStore = NotificationsStore.getInstance()
    private questionnairesStore = QuestionnairesStore.getInstance()
    private usersStore = UsersStore.getInstance()
    private eventsStore = EventsStore.getInstance()
    private paymentsStore = PaymentsStore.getInstance()
    private catalogProductsStore = CatalogProductsStore.getInstance()
    private ls = LocalizationService.getInstance()
    private externalDataStore = ExternalDataStore.getInstance()
    private settingsStore = SettingsStore.getInstance()
    private merchantsStore = MerchantsStore.getInstance()
    private affiliatesStore = AffiliatesStore.getInstance()
    private creditsStore = CreditsStore.getInstance()
    private scheduleConfigurationStore = ScheduleConfigurationStore.getInstance()

    private static _instance: HttpActionsService

    private constructor() { }

    public static getInstance(): HttpActionsService {
        return this._instance || (this._instance = new this())
    }

    @observable
    public reqNum: number = 0

    private notifications: Array<INotificationEntity> = []

    public getEndPoint(url: string, https?: boolean): string {
        return (https ? this.apiCCHttpsHost : this.apiCCHost) + url
    }

    public getExternalEndPoint(url: string): string {
        return this.apiCCExternalHttpHost + url
    }

    private incReqNum() {
        this.reqNum++
    }

    private decReqNum() {
        this.reqNum = this.reqNum ? this.reqNum - 1 : 0
    }

    private processNotification(
        msg: string, type: 'danger' | 'warning' | 'success' | 'info', show?: boolean, info?: string) {
        show = undefined !== show ? show : true
        if (show) {
            let alert = new NotificationEntity(type, `${this.ls.t(msg)} ${info! === undefined ? '' : info}`)
            this.notifications.push(alert)
        }
        if (!this.reqNum) {
            this.notificationsStore.setList(this.notifications)
            this.notifications = []
        }
    }

    public async toggleBlockUser(userId: string) {
        if (!userId) {
            return
        }

        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {

            let response = await new RequestExecutorHelper().post(
                self.getEndPoint(`/api/Account/ToggleBlockUser/${userId}`),
                null,
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()
                this.usersStore.toggleItemIsLockoutEnabled(data)
                if (data) {
                    this.usersStore.toggleItemIsActive(!data)
                }
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Can\'t toggle user blocked', 'danger', true)
            }
        } catch (ex) {
            self.decReqNum()
            self.processNotification('Can\'t toggle user blocked', 'danger', true)
        }
    }

    public login(name: string, password: string): void {
        const self = this

        Nav.getInstance().init()

        self.incReqNum()

        new RequestExecutorHelper().postUrlEncoded(
            self.getEndPoint('/connect/token'),
            {
                grant_type: 'password',
                username: name,
                password: password,
                scope: this.openIdScope
            },
            {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification('Welcome!', 'success', true)

                    response.json().then((data) => {
                        self.user.setData(
                            data['token_type'],
                            data['access_token'],
                            data['id_token'],
                            data['expires_in'],
                            data['refresh_token']
                        )
                        Nav.getInstance().addRoleDependentItems()
                        AuthService.getInstance().refreshStart()
                        history.push('/')
                    })
                } else {
                    self.decReqNum()
                    self.user.killSession()
                    self.processNotification(
                        'The username/password couple is invalid'
                        + ': '
                        + response['statusText'],
                        'danger')
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification(error.message, 'danger')
            })
    }

    public refreshOAuthTokens() {
        if (!window.localStorage.getItem('refreshToken')) {
            return
        }

        const self = this

        Nav.getInstance().init()

        self.incReqNum()

        new RequestExecutorHelper().postUrlEncoded(
            self.getEndPoint('/connect/token'),
            {
                grant_type: 'refresh_token',
                refresh_token: window.localStorage.getItem('refreshToken'),
            },
            {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    if (!self.user.checkSession) {
                        self.processNotification('Welcome!', 'success', true)
                    }

                    response.json().then((data) => {
                        self.user.updateAcceptToken(
                            data['token_type'],
                            data['access_token']
                        )
                    })
                } else {
                    self.decReqNum()
                }
            })
            .catch((error) => {
                self.decReqNum()
            })
    }

    public async findQuestionnaires(request: FindQRequest) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {

            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Questionnaire/FindQuestionnaires'),
                JSON.stringify(request),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()

                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount.Find = {
                    items: data.questionnaires,
                    pageCount: data.pageCount
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {

                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount = {
                    All: {
                        items: [],
                        pageCount: 0
                    },
                    Draft: {
                        items: [],
                        pageCount: 0
                    },
                    InProgressCreditConsultant: {
                        items: [],
                        pageCount: 0
                    },
                    Scored: {
                        items: [],
                        pageCount: 0
                    },
                    InProgressCreditExpert: {
                        items: [],
                        pageCount: 0
                    },
                    Find: {
                        items: [],
                        pageCount: 0
                    }
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)

                this.notificationsStore.setList(
                    [
                        new NotificationEntity('danger', self.ls.t!('Can\'t get questionnaries'))
                    ]
                )
            }
        } catch (ex) {
            self.decReqNum()
            self.processNotification('Can\'t get questionnaries', 'danger', true)
        }
    }

    public async getQuestionnaires(
        statuses: Array<QuestionnaireStatus> | null,
        page: number,
        pageSize: number,
        filter: any, sort: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        let filterClone = _.cloneDeep(filter)
        let sortClone = _.cloneDeep(sort)

        try {

            if (statuses) {
                let statusFilter = ''
                statuses.forEach(status => {
                    if (status || status === 0) {
                        statusFilter += `${status}|`
                    }
                })

                filterClone.push({
                    id: 'statuses',
                    value: statusFilter
                })
            }

            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Questionnaire/GetQuestionnaires'),
                JSON.stringify(new PaginationRequest(page, pageSize, filterClone, sortClone)),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()

                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount.All = {
                    items: data.questionnaires,
                    pageCount: data.pageCount
                }

                if (_.includes(
                    statuses,
                    QuestionnaireStatus.Draft)) {

                    listByTypeAndPageCount.Draft = {
                        items: data.questionnaires,
                        pageCount: data.pageCount
                    }
                }

                if (_.includes(
                    statuses,
                    QuestionnaireStatus.InProgressCreditConsultant)) {

                    listByTypeAndPageCount.InProgressCreditConsultant = {
                        items: data.questionnaires,
                        pageCount: data.pageCount
                    }
                }

                if (_.includes(
                    statuses,
                    QuestionnaireStatus.InProgressCreditExpert)) {
                    listByTypeAndPageCount.InProgressCreditExpert = {
                        items: data.questionnaires,
                        pageCount: data.pageCount
                    }
                }

                if (_.includes(
                    statuses,
                    QuestionnaireStatus.Scored)) {
                    listByTypeAndPageCount.Scored = {
                        items: data.questionnaires,
                        pageCount: data.pageCount
                    }
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount = {
                    All: {
                        items: [],
                        pageCount: 0
                    },
                    Draft: {
                        items: [],
                        pageCount: 0
                    },
                    InProgressCreditConsultant: {
                        items: [],
                        pageCount: 0
                    },
                    Scored: {
                        items: [],
                        pageCount: 0
                    },
                    InProgressCreditExpert: {
                        items: [],
                        pageCount: 0
                    },
                    Find: {
                        items: [],
                        pageCount: 0
                    }
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)

                this.notificationsStore.setList(
                    [
                        new NotificationEntity('danger', self.ls.t!('Can\'t get questionnaries'))
                    ]
                )
            }
        } catch (ex) {
            self.decReqNum()
            self.processNotification('Can\'t get questionnaries', 'danger', true)
        }
    }

    async getHistoryQuestionnaires(page: number, pageSize: number, filter: any, sort: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Questionnaire/GetHistoryQuestionnaires'),
                JSON.stringify(new PaginationRequest(page, pageSize, filter, sort)),
                self.user.getAuthHeader()!)

            self.decReqNum()
            if (response['ok'] && 200 === response.status) {
                let data = await response.json()

                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount.All = {
                    items: data.questionnaires,
                    pageCount: data.pageCount
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                let listByTypeAndPageCount = this.questionnairesStore.getListByTypeAndPageCount

                listByTypeAndPageCount.All = {
                    items: [],
                    pageCount: 0
                }

                this.questionnairesStore.setListByTypeAndPageCount(listByTypeAndPageCount)
                this.notificationsStore.setList(
                    [
                        new NotificationEntity('danger', self.ls.t!('Can\'t get history questionnaires'))
                    ]
                )
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Can\'t get history questionnaires', 'danger', true)
        }

        // new RequestExecutorHelper().post(
        //     self.getEndPoint('/api/Questionnaire/GetHistoryQuestionnaires'),
        //     JSON.stringify(new PaginationRequest(page, pageSize, filter, sort)),
        //     self.user.getAuthHeader()!)
        //     .then((response) => {
        //         self.decReqNum()
        //         alert(response.status)
        //         if (response['ok'] && 200 === response.status) {
        //             response.json().then((data) => {
        //                 this.questionnairesStore.setPageCountAll(data.pageCount)
        //                 this.questionnairesStore.setListAll(data.questionnaires)
        //             })
        //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
        //             history.push('/login')
        //         } else {
        //             this.questionnairesStore
        //                 .setPageCountAll(1)
        //             this.questionnairesStore.setListAll([])
        //             this.notificationsStore.setList(
        //                 [
        //                     new NotificationEntity('danger', self.ls.t!('Can\'t get history questionnaires'))
        //                 ]
        //             )
        //         }
        //     })
        //     .catch((error) => {
        //         alert(error)
        //         self.decReqNum()
        //         self.processNotification('Can\'t get history questionnaires', 'danger', true)
        //     })
    }

    // async getHistoryEvents() {
    //     if (!this.user.checkSession) {
    //         history.push('/login')
    //     }

    //     const self = this
    //     self.incReqNum()

    //     try {
    //         let response = await new RequestExecutorHelper().get(
    //             self.getEndPoint('/api/TroubleEvents/GetHistoryTroubleEvents'),
    //             undefined,
    //             self.user.getAuthHeader()!)

    //         self.decReqNum()

    //         if (response['ok'] && 200 === response.status) {
    //             let data = await response.json()
    //             this.eventsStore.setList(data.troubleEvents)
    //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
    //             history.push('/login')
    //         } else {
    //             this.eventsStore.setList([])
    //             this.notificationsStore.setList(
    //                 [
    //                     new NotificationEntity('danger', self.ls.t!('Can\'t get trouble events'))
    //                 ]
    //             )
    //         }
    //     } catch (error) {
    //         self.decReqNum()
    //         self.processNotification('Get history trouble events error!', 'danger', true)
    //     }

    //     // new RequestExecutorHelper().get(
    //     //     self.getEndPoint('/api/TroubleEvents/GetHistoryTroubleEvents'),
    //     //     undefined,
    //     //     self.user.getAuthHeader()!)
    //     //     .then((response) => {
    //     //         self.decReqNum()
    //     //         if (response['ok'] && 200 === response.status) {
    //     //             response.json().then((data) => {
    //     //                 this.eventsStore.setList(data.troubleEvents)
    //     //             })
    //     //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
    //     //             history.push('/login')
    //     //         } else {
    //     //             this.eventsStore.setList([])
    //     //             this.notificationsStore.setList(
    //     //                 [
    //     //                     new NotificationEntity('danger', self.ls.t!('Can\'t get trouble tvents'))
    //     //                 ]
    //     //             )
    //     //         }
    //     //     })
    //     //     .catch((error) => {
    //     //         self.decReqNum()
    //     //         self.processNotification('Get history trouble events error!', 'danger', true)
    //     //     })
    // }

    @action.bound
    public clearQuestionnaire() {
        this.questionnairesStore.setItem(null)
    }

    @action.bound
    public async getQuestionnaire(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.getAffiliates()

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().get(
                self.getEndPoint('/api/Questionnaire/GetById/' + id), undefined, self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()

                // await this.getCurrentNotPaidPenalty(data.questionnaire.credit.creditNumber)
                await this.getCreditLimit(
                    // data.questionnaire.client.email,
                    '',
                    data.questionnaire.client.passport.pin,
                    data.questionnaire.client.passport.number)

                self.questionnairesStore.setItem(data['questionnaire'])
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.clearQuestionnaire()
                self.processNotification(
                    'Get questionnaire error!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.clearQuestionnaire()
            self.decReqNum()
            self.processNotification('Get questionnaire error!', 'danger', true, `${error}`)
        }
    }

    // // @action.bound
    // // public async getCreditLimitByEmail(email: string) {
    // //     if (!this.user.checkSession) {
    // //         history.push('/login')
    // //     }

    // //     if (!email) {
    // //         return
    // //     }

    // //     const self = this

    // //     self.incReqNum()

    // //     try {
    // //         var response = await new RequestExecutorHelper().get(
    // //             self.getEndPoint(
    // //                 '/api/Questionnaire/GetCreditLimitByClientEmail/' + email),
    // //             undefined,
    // //             self.user.getAuthHeader()!
    // //         )

    // //         self.decReqNum()

    // //         if (response['ok'] && 200 === response['status']) {
    // //             let data = await response.json()
    // //             this.questionnairesStore.setCreditLimitByEmail(data)
    // //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
    // //             history.push('/login')
    // //         } else {
    // //             self.processNotification(
    // //                 'Get Credit Limit By Email error!',
    // //                 'danger',
    // //                 true,
    // //                 ` response status: ${response.status} ${await response.text()}`)
    // //         }
    // //     } catch (error) {
    // //         self.decReqNum()
    // //         self.processNotification('Get Credit Limit By Email error!', 'danger', true, `${error}`)
    // //     }
    // // }

    @action.bound
    public async getCreditLimit(
        email: string,
        pin: string,
        passportNumber: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        if (!email && !pin && !passportNumber) {
            return
        }

        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().post(
                self.getEndPoint(
                    '/api/Questionnaire/GetCreditLimit/'),
                JSON.stringify({
                    pin: pin,
                    email: email,
                    passportNumber: passportNumber
                }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                this.questionnairesStore.setCreditLimit(data)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Get Credit Limit error!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Credit Limit error!', 'danger', true, `${error}`)
        }
    }

    // @action.bound
    // async getPaymentScheduleByQuestionnaireId(id: string) {
    //     if (!this.user.checkSession) {
    //         history.push('/login')
    //     }

    //     const self = this
    //     self.incReqNum()

    //     try {

    //         let response = await new RequestExecutorHelper()
    //             .get(
    //                 self.getEndPoint('/api/Questionnaire/GetById/' + id),
    //                 undefined,
    //                 self.user.getAuthHeader()!
    //             )
    //         let data = await response.json()

    //         let scheduleArr: Array<PaymentScheduleItemModel> =
    //             getPaymentSchedule(data.questionnaire.credit.creditCondition.paymentsScheduleJson)

    //         data.questionnaire.credit.creditCondition.paymentsScheduleJson = scheduleArr
    //         this.questionnairesStore.setItem(data.questionnaire)
    //         self.decReqNum()
    //     } catch (error) {
    //         self.decReqNum()
    //         self.processNotification('Get payment schedule fail!', 'danger', true)
    //     }
    // }

    public async createQuestionnaire(q: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        q.id = null
        q.externalKey = null
        delete q.credit.creditCondition.paymentsScheduleJson

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Questionnaire/CreateQuestionnaire'),
                JSON.stringify({ questionnaire: q }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                self.processNotification('Create questionnaire success!', 'success')
                history.push('/questionnaires')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Create questionnaire error!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
                QuestionnairesStore.getInstance().setItem(q)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Create questionnaire error!', 'danger', true, `${error}`)
            QuestionnairesStore.getInstance().setItem(q)
        }

        // new RequestExecutorHelper().post(
        //     self.getEndPoint('/api/Questionnaire/CreateQuestionnaire'),
        //     JSON.stringify({ questionnaire: q }),
        //     self.user.getAuthHeader()!
        // )
        //     .then(response => {
        //         self.decReqNum()

        //         if (response['ok'] && 200 === response['status']) {
        //             self.processNotification('Create questionnaire success!', 'success')
        //             history.push('/questionnaires')
        //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
        //             history.push('/login')
        //         }
        //     })
        //     .catch((error) => {
        //         self.decReqNum()
        //         self.processNotification('Create questionnaire error!', 'danger', true)
        //     }
        //     )
        //     .catch((error) => {
        //         self.decReqNum()
        //         self.processNotification('Create questionnaire error!', 'danger', true)
        //     })
    }

    public async updateQuestionnaire(q: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateQuestionnaire'),
                JSON.stringify({ questionnaire: q }),
                this.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                self.processNotification('updateQuestionnaireSuccess', 'success')
                history.push('/questionnaires')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'updateQuestionnaireFail',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
                QuestionnairesStore.getInstance().setItem(q)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('updateQuestionnaireFail', 'danger', true, `${error}`)
            QuestionnairesStore.getInstance().setItem(q)
        }

        // new RequestExecutorHelper().put(
        //     self.getEndPoint('/api/Questionnaire/UpdateQuestionnaire'),
        //     JSON.stringify({ questionnaire: q }),
        //     this.user.getAuthHeader()!
        // )
        //     .then(response => {
        //         self.decReqNum()

        //         if (response['ok'] && 200 === response['status']) {
        //             response.json()
        //                 .then((data) => {
        //                     self.processNotification('updateQuestionnaireSuccess', 'success', true)
        //                     history.push('/questionnaires')
        //                 })
        //                 .catch((error) => {
        //                     self.processNotification('updateQuestionnaireFail', 'danger', true)
        //                 })
        //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
        //             history.push('/login')
        //         } else {
        //             response.json()
        //                 .then((data) => {
        //                     self.processNotification(data['Error'], 'danger', true)
        //                     history.push('/questionnaires')
        //                 })
        //         }
        //     })
        //     .catch((error) => {
        //         self.decReqNum()
        //         self.processNotification('updateQuestionnaireFail', 'danger', true)
        //     })
    }

    public async updateCreditProducts(creditId: string, products: Array<IProduct>) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateCreditProducts'),
                JSON.stringify({
                    creditId: creditId,
                    products: products
                }),
                this.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                // var data = await response.json()
                self.processNotification(`Update Credit Products success!`, 'success', true, ` id: ${creditId}`)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Update Credit Products fail!`, 'danger', true, ` id: ${creditId}`)
                self.catalogProductsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(
                `Update Credit Products fail!`,
                'danger',
                true,
                ` id: ${creditId} error: ${error}`
            )

        }
    }

    public async changeStatus(qId: string, status: QuestionnaireStatus, comment: string, cancelReason: CancelReason) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .put(
                    self.getEndPoint('/api/Questionnaire/ChangeStatus'),
                    JSON.stringify({
                        questionnaireId: qId,
                        status: status,
                        comment: comment,
                        cancelReason: cancelReason
                    }),
                    self.user.getAuthHeader()!
                )
            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Change status success!', 'success', true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Change status fail!',
                    'danger',
                    true,
                    `${JSON.stringify(await response.json())}`)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Change status fail!', 'danger', true, `${error}`)
        }
    }

    public async changeStatusWithAssign(userId: string, qId: string, status: QuestionnaireStatus, comment: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().put(
                    self.getEndPoint('/api/Questionnaire/ChangeStatusWithAssign'),
                    JSON.stringify({
                        questionnaireId: qId,
                        status: status,
                        comment: comment,
                        userId: userId
                    }),
                    self.user.getAuthHeader()!
                )
            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Assign success!', 'success', true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Assign fail!',
                    'danger',
                    true,
                    `${JSON.stringify(await response.json())}`)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Assign fail!', 'danger', true, `${error}`)
        }
    }

    public addComment(qId: string, comment: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Questionnaire/AddComment'),
            JSON.stringify({
                questionnaireId: qId,
                comment: comment
            }),
            self.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification('Add comment success!', 'success', true)

                    response.json()
                        .then((data) => {
                            self.questionnairesStore.addCommentToItem(data.comment)
                        })
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification('Add comment fail!', 'danger', true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Add comment fail!', 'danger', true)
            })
    }

    @action.bound
    public getUsers() {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        new RequestExecutorHelper().get(
            self.getEndPoint('/api/Account/GetUsers'),
            undefined,
            self.user.getAuthHeader()!)
            .then((response) => {
                self.decReqNum()

                if (response['ok'] && 200 === response.status) {
                    response.json().then((data) => {
                        this.usersStore.setList(data.users)
                    })
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    this.notificationsStore.setList(
                        [
                            new NotificationEntity(
                                'danger',
                                self.ls.t!('Can\'t get users:') + ' ' + response.status)
                        ]
                    )
                    history.push('/login')
                } else {
                    this.usersStore.setList([])
                    this.notificationsStore.setList(
                        [
                            new NotificationEntity('danger', self.ls.t!('Can\'t get users'))
                        ]
                    )
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification('Can\'t get users', 'danger', true)
            })
    }

    @action.bound
    public getUser(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().get(
            self.getEndPoint('/api/Account/GetUserById/' + id), undefined, self.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    response.json()
                        .then((data) => {
                            self.usersStore.setItem(data['user'])
                        })
                        .catch((error) => {
                            self.processNotification('Can\'t get user', 'danger', true)
                        })

                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    this.notificationsStore.setList(
                        [
                            new NotificationEntity(
                                'danger', self.ls.t!('Can\'t get user:')
                                + ' '
                            + response.status)
                        ]
                    )
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification('Can\'t get user', 'danger', true)
            })
    }

    public createUser(u: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Account/register'),
            JSON.stringify(u),
            self.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification('Create user success!', 'success', true)
                    history.push('/users')
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification('Error create user', 'danger', true)
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification('Error create user', 'danger', true)
            })
    }

    public updateUser(u: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Account/UpdateUser'),
            JSON.stringify(u),
            this.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()
                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Update user success!',
                        'success',
                        true)
                    history.push('/users')
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Update user fail!',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification(
                    'Update user fail!',
                    'danger',
                    true)
            })
    }

    public changePassword(p: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Account/ChangePassword'),
            JSON.stringify(p),
            this.user.getPostFormAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Change password success!',
                        'success',
                        true)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Change password fail!',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification(
                    'Change password fail!',
                    'danger',
                    true)
            })
    }

    public resetPassword(email: string) {
        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Account/ForgotPassword'),
            JSON.stringify({
                'email': email
            }),
            {
                'Content-Type': 'application/json'
            }
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Reset password success',
                        'success',
                        true)
                    history.push('/login')
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Reset password fail',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()

                self.processNotification(
                    'Reset password fail',
                    'danger',
                    true)
            })
    }

    public async recoverPassword(p: any) {
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Account/ResetPassword'),
                JSON.stringify(p),
                // this.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                history.push('/login')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                let data = await response.json()
                self.processNotification(
                    'Recovery password fail',
                    'danger',
                    true,
                    data[Object.keys(data)[0]])
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(
                'Recovery password fail',
                'danger',
                true,
                error)
        }
    }

    sendBlame(b: any) {
        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Feedback'),
            JSON.stringify(b),
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    response.json().then((data) => {
                        console.info(data, 'response')
                    })
                        .catch((error) => {
                            console.info(error)
                        })
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    console.info('error')
                }
            })
            .catch((error) => {
                self.decReqNum()

                console.info(error, 'response')
            })
    }

    resendConfirmaionEmail(userId: string): void {
        if (!this.user.checkSession) {
            return
        }

        const self = this
        if (!userId) {
            self.processNotification(
                'Please save user first',
                'danger',
                true)
            return
        }

        self.incReqNum()
        new RequestExecutorHelper().post(
            self.getEndPoint('/api/Account/ResendEmailConfirmCode'),
            JSON.stringify({
                'userId': userId
            })
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Resend email confirmation success',
                        'success',
                        true)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Resend email confirmation fail',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification(
                    'Resend email confirmation fail',
                    'danger',
                    true)
            })
    }

    updateQuestionnaireContentData(clId: string, description: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().put(
            self.getEndPoint('/api/ContentLinks/UpdateContentLinkDescription'),
            JSON.stringify({
                'contentLinkId': clId,
                'description': description
            }),
            this.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()
                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Update conent-data success!',
                        'success',
                        true)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Update conent-data fail!',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification(
                    'Update conent-data fail!',
                    'danger',
                    true)
            })
    }

    uploadQuestionnaireFile(qId: string, formData: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        axios.default.post(
            self.getEndPoint('/api/ContentLinks/UploadQuestionnaireFile/' + qId),
            formData,
            {
                'headers': this.user.getPostMultipartFormDataAuthHeader()
            }
        )
            .then(response => {
                self.decReqNum()
                if (200 === response['status']) {
                    self.processNotification(
                        'Create conent-data success!',
                        'success',
                        true)
                    QuestionnairesStore.getInstance().addItemContentLink(qId, response.data)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Create conent-data fail!',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification(
                    'Create conent-data fail!',
                    'danger',
                    true)
            })
    }

    deleteQuestionnaireFile(qId: string, clId: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().post(
            self.getEndPoint('/api/ContentLinks/DeleteQuestionnaireFile/' + clId),
            {
                contentLinkId: clId
            },
            this.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()
                if (response['ok'] && 200 === response['status']) {
                    self.processNotification(
                        'Delete conent-data success!',
                        'success',
                        true)
                    QuestionnairesStore.getInstance().deleteItemContentLink(clId)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification(
                        'Delete conent-data fail!',
                        'danger',
                        true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification(
                    'Delete conent-data fail!',
                    'danger',
                    true)
            })
    }

    private async GetQuestionnaireByEvent(eventId: string) {
        return (
            await
                (await new RequestExecutorHelper().get(
                    this.getEndPoint('/api/Questionnaire/GetQuestionnaireByTroubleEventId/' + eventId),
                    undefined,
                    this.user.getAuthHeader()!
                )).json()
        ).questionnaire
    }

    // private async GetAndReturnPaymentsByTroubleEventId(eventId: string) {
    //     const self = this

    //     return (await (await new RequestExecutorHelper().get(
    //         self.getEndPoint('/api/Payment/GetPaymentsByTroubleEventId/' + eventId),
    //         undefined,
    //         self.user.getAuthHeader()!
    //     )).json()).payments
    // }

    @action.bound
    public async getEvents(
        status: TroubleEventStatus | null,
        page: number,
        pageSize: number,
        filter: any, sort: any,
        isHistoryData: Boolean = false) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        let filterClone = _.cloneDeep(filter)
        let sortClone = _.cloneDeep(sort)

        const self = this
        self.incReqNum()
        try {
            if (status || status === 0) {
                filterClone.push({
                    id: 'statuses',
                    value: status
                })
            }

            let response = await new RequestExecutorHelper()
                .post(
                    self
                        .getEndPoint(!isHistoryData ?
                            '/api/TroubleEvents/GetTroubleEvents/' :
                            '/api/TroubleEvents/GetHistoryTroubleEvents'),
                    JSON
                        .stringify(new PaginationRequest(page, pageSize, filterClone, sortClone)),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                if (data) {

                    for (let i = 0; i < data.troubleEvents.length; i++) {
                        data.troubleEvents[i].questionnaire = data.troubleEvents[i].credit.questionnaire
                        //     await self.GetQuestionnaireByEvent(data.troubleEvents[i].id)
                    }

                    if (status === TroubleEventStatus.New) {
                        this.eventsStore.setNewList(data.troubleEvents)
                        this.eventsStore.setPageCountNEW(data.pageCount)
                    } else if (status === TroubleEventStatus.InProgress) {
                        this.eventsStore.setInProgressList(data.troubleEvents)
                        this.eventsStore.setPageCountInProgress(data.pageCount)
                    } else {
                        this.eventsStore.setList(data.troubleEvents)
                        this.eventsStore.setPageCountAll(data.pageCount)
                    }
                }
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Can\'t get trouble events', 'danger', true)
            }
        } catch (ex) {
            self.decReqNum()
            self.processNotification('Can\'t get trouble events', 'danger', true)
        }
    }

    async getEvent(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.getAffiliates()

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint('/api/TroubleEvents/GetTroubleEventById/' + id), undefined, self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                data.troubleEvent.questionnaire =
                    await self.GetQuestionnaireByEvent(data.troubleEvent.id)

                // await this.getCurrentNotPaidPenalty(data.troubleEvent.questionnaire.credit.creditNumber)

                await this.getCreditLimit(
                    // data.troubleEvent.questionnaire.client.email,
                    '',
                    data.troubleEvent.questionnaire.client.passport.pin,
                    data.troubleEvent.questionnaire.client.passport.number)

                this.eventsStore.setItem(data.troubleEvent)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Can\'t get trouble event',
                    'danger',
                    true,
                    `response status: ${response.status}`
                )
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Can\'t get trouble event', 'danger', true, `${error}`)
        }
    }

    // // not used, but can be usable on async update
    // async getPaymentsByQuestionnaireId(qId: string) {
    //     if (!this.user.checkSession) {
    //         history.push('/login')
    //     }

    //     const self = this

    //     self.incReqNum()

    //     try {
    //         var response = await new RequestExecutorHelper().get(
    //             self.getEndPoint('/api/Payment/getPaymentsByQuestionnaireId/' + qId),
    //             undefined,
    //             self.user.getAuthHeader()!
    //         )

    //         self.decReqNum()

    //         if (response['ok'] && 200 === response.status) {
    //             var data = await response.json()
    //             this.paymentsStore.setList(data['payments'])
    //         } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
    //             history.push('/login')
    //         } else {
    //             self.processNotification('Get payments error!', 'danger', true, `response ${response.status}`)
    //         }
    //     } catch (error) {
    //         self.processNotification('Get payments error!', 'danger', true, `error: ${error.message}`)
    //     }
    // }

    getPaymentsByTroubleEventId(eventId: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().get(
            self.getEndPoint('/api/Payment/GetPaymentsByTroubleEventId/' + eventId),
            undefined,
            self.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    response.json()
                        .then((data) => {
                            this.paymentsStore.setList(data['payments'])
                        })
                        .catch((error) => {
                            self.processNotification('Get payments error!', 'danger', true)
                        })
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification('Get payments error!', 'danger', true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Get payments error!', 'danger', true)
            })
    }

    @action.bound
    changeTroubleEventStatus(teId: string, status: TroubleEventStatus) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().put(
            self.getEndPoint('/api/TroubleEvents/ChangeStatus'),
            JSON.stringify({
                'troubleEventId': teId,
                'status': status
            }),
            self.user.getAuthHeader()!
        )
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    self.processNotification('Change trouble event status success!', 'success')
                    response.json()
                        .then((data) => {
                            this.eventsStore.setItem(data['troubleEvent'])
                        })
                        .catch((error) => {
                            self.processNotification('Change trouble event status fail', 'danger', true)
                        })
                    // EventsStore.getInstance().setItemStatus(response.status)
                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    self.processNotification('Change trouble event status fail!', 'danger', true)
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Change trouble event status fail!', 'danger', true)
            })
    }

    @action.bound
    downloadDocument(qID: string, documentType: DownloadDocumentType) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().get(
            self.getEndPoint('/api/Document/GetDocument/' + qID + '/' + documentType),
            undefined,
            self.user.getAuthHeader()!)
            .then(response => {
                self.decReqNum()
                return response.blob()
            })
            .then(blob => {
                self.decReqNum()
                if (blob.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                    self.processNotification('Download document status fail!', 'danger', true)
                    return
                }

                var url = window.URL.createObjectURL(blob)
                var a = document.createElement('a')
                a.href = url
                a.download = 'document.docx'
                // we need to append the element to the dom -> otherwise it will not work in firefox
                document.body.appendChild(a)
                a.click()
                a.remove()  // afterwards we remove the element again         

                self.processNotification('Download document success!', 'success', true)
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Download document status fail!', 'danger', true)
            })
    }

    async updateCreditConditions(creditCondition: ICreditCondition, comment?: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateCreditConditions'),
                JSON.stringify({
                    creditCondition: creditCondition,
                    comment: comment
                }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Update Credit Conditions success!', 'success')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Update Credit Conditions fail!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Update Credit Conditions fail!', 'danger', true, `${error}`)
        }
    }

    async updateCourtDecision(courtDecision: CourtDecision, comment?: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateCourtDecision'),
                JSON.stringify({
                    courtDecision: courtDecision,
                    comment: comment
                }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Update Court Decision success!', 'success')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Update Court Decision fail!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Update Court Decision fail!', 'danger', true, `${error}`)
        }
    }

    async updateIMEIList(request: MobileIMEIRequest) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateIMEIList'),
                JSON.stringify(request),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Update IMEI List success!', 'success')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Update IMEI List fail!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Update IMEI List fail!', 'danger', true, `${error}`)
        }
    }

    async updateAgentInfo(agentInfo: IAgentInfo, comment?: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            var response = await new RequestExecutorHelper().put(
                self.getEndPoint('/api/Questionnaire/UpdateAgentInfo'),
                JSON.stringify({
                    agentInfo: agentInfo,
                    comment: comment
                }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.questionnairesStore.setItem(data.questionnaire)
                self.processNotification('Update Agent Info success!', 'success')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Update Agent Info fail!',
                    'danger',
                    true,
                    ` response status: ${response.status} ${await response.text()}`)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Update Agent Info fail!', 'danger', true, `${error}`)
        }
    }

    async toggleIsActiveUser(userId?: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()
        userId = userId ? userId : this.user.id

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Account/ToggleIsActive/' + userId),
                JSON.stringify({
                    'userId': userId
                }),
                self.user.getAuthHeader()!
            )

            self.decReqNum()
            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                this.usersStore.toggleItemIsActive(data['isActive'])
                self.processNotification('Change user status success!', 'success')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    'Change user status fail!',
                    'danger',
                    true,
                    `${JSON.stringify(await response.json())}`)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Change user status fail!', 'danger', true, `${error}`)
        }
    }

    async getExternalDataByPhones(phoneNumbers: string[]) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        this.externalDataStore.isError = false
        this.externalDataStore.setData(null)
        const self = this

        self.incReqNum()

        await phoneNumbers.forEach(async phoneNumber => {
            try {
                let response = await new RequestExecutorHelper()
                    .get(
                        this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByPhone/' + phoneNumber),
                        undefined,
                        self.user.getAuthHeader()!)

                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    let data = await response.json()
                    if (data.creditInfoItems) {
                        data.creditInfoItems.forEach(async (creditInfo: any) => {

                            if (!creditInfo) {
                                return
                            }

                            if (creditInfo.creditNumber) {
                                let responsePaymentSchedule = await new RequestExecutorHelper()
                                    .get(
                                        this.getExternalEndPoint(
                                            '/api/Payments/' + creditInfo.creditNumber + '/PaymentSchedule'
                                        )
                                    )
                                self.decReqNum()

                                if (response['ok'] && 200 === response['status']) {
                                    let dataPaymentSchedule = await responsePaymentSchedule.json()
                                    creditInfo.paymentSchedule = dataPaymentSchedule.paymentSchedule
                                }
                            }
                            this.externalDataStore.pushData(creditInfo)
                        })
                    }

                } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                    history.push('/login')
                } else {
                    this.externalDataStore.isError = true
                    this.externalDataStore.setData(null)
                }
            } catch (error) {
                self.decReqNum()
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
                self.processNotification('Get External Data By Phone fail!', 'danger', true)
            }
        })
    }

    // getExternalDataByPhone(phoneNumber: string) {
    //     if (!this.user.checkSession) {
    //         history.push('/login')
    //     }
    //     this.externalDataStore.setData(null)
    //     const self = this

    //     self.incReqNum()

    //     new RequestExecutorHelper()
    //         .get(this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByPhone/' + phoneNumber))
    //         .then(response => {
    //             self.decReqNum()

    //             if (response['ok'] && 200 === response['status']) {
    //                 response.json()
    //                     .then((data) => {

    //                         if (data['Error']) {
    //                             this.externalDataStore.isError = true
    //                             this.externalDataStore.setData(null)
    //                             return
    //                         }

    //                         this.externalDataStore.setData(data)
    //                     })
    //                     .catch((error) => {
    //                         this.externalDataStore.isError = true
    //                         this.externalDataStore.setData(null)
    //                         self.processNotification('Get External Data By Phone fail!', 'danger', true)
    //                     })
    //             } else {
    //                 this.externalDataStore.isError = true
    //                 this.externalDataStore.setData(null)
    //             }
    //         })
    //         .catch((error) => {
    //             self.decReqNum()
    //             this.externalDataStore.isError = true
    //             this.externalDataStore.setData(null)
    //             self.processNotification('Get External Data By Phone fail!', 'danger', true)
    //         })
    // }

    async getExternalDataByCreditNumber(creditNumber: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        this.externalDataStore.isError = false
        this.externalDataStore.setData(null)
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByCreditNumber/' + creditNumber),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                data.creditInfoItems.forEach(async (creditInfo: any) => {

                    if (!creditInfo) {
                        return
                    }

                    if (creditInfo.creditNumber) {
                        let responsePaymentSchedule = await new RequestExecutorHelper()
                            .get(
                                this.getExternalEndPoint(
                                    '/api/Payments/' + creditInfo.creditNumber + '/PaymentSchedule'
                                )
                            )
                        self.decReqNum()

                        if (response['ok'] && 200 === response['status']) {
                            let dataPaymentSchedule = await responsePaymentSchedule.json()
                            creditInfo.paymentSchedule = dataPaymentSchedule.paymentSchedule
                        }
                    }
                    this.externalDataStore.pushData(creditInfo)
                })
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
            }
        } catch (error) {
            self.decReqNum()
            this.externalDataStore.isError = true
            this.externalDataStore.setData(null)
            self.processNotification('Get External Data By Credit Number fail!', 'danger', true)
        }
    }

    async getExternalDataByPassport(passport: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        this.externalDataStore.isError = false
        this.externalDataStore.setData(null)
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByPassport/' + passport),
                    undefined,
                    self.user.getAuthHeader()!)
            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()

                data.creditInfoItems.forEach(async (creditInfo: any) => {

                    if (!creditInfo) {
                        return
                    }

                    if (creditInfo.creditNumber) {
                        let responsePaymentSchedule = await new RequestExecutorHelper()
                            .get(
                                this.getExternalEndPoint(
                                    '/api/Payments/' + creditInfo.creditNumber + '/PaymentSchedule'
                                )
                            )
                        self.decReqNum()
                        if (response['ok'] && 200 === response['status']) {
                            let dataPaymentSchedule = await responsePaymentSchedule.json()
                            creditInfo.paymentSchedule = dataPaymentSchedule.paymentSchedule
                        }
                    }
                    this.externalDataStore.pushData(creditInfo)
                })
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
            }
        } catch (error) {
            self.decReqNum()
            this.externalDataStore.isError = true
            this.externalDataStore.setData(null)
            self.processNotification('Get External Data By Passport fail!', 'danger', true)
        }
    }

    getEmployeeKPI(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        if (!id.length) {
            return
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper().get(
            ReportsService.getIframe('EmployeeKPI') + id,
            undefined,
            self.user.getAuthHeader()!)
            .then(response => {
                self.decReqNum()
                self.processNotification('Get data success', 'success', true)
                return response
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Get data fail', 'danger', true)
            })
    }

    async getQuestionnairePrefillDataByPin(prefilData: QuestionnairePrefillData) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        this.externalDataStore.isError = false
        this.externalDataStore.setClientGovDataByPin(null)
        const self = this

        self.incReqNum()

        this.questionnairesStore.setPrefillDataFromExternalSource(null, prefilData)

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    self.getEndPoint('/api/GovernmentServices/C2B/') + prefilData.pin,
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()
                if (data['Error']) {
                    this.questionnairesStore.setPrefillDataFromExternalSource(null, prefilData)
                    return
                }

                data = data['userInfoC2B']
                this.questionnairesStore.setPrefillDataFromExternalSource(data, prefilData)
                this.externalDataStore.setClientGovDataByPin(data)
            } else {
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
            }
        } catch {
            self.decReqNum()
            this.externalDataStore.isError = true
            this.externalDataStore.setData(null)
            this.questionnairesStore.setPrefillDataFromExternalSource(null, prefilData)
            self.processNotification('Get data by pin failed', 'danger', true)
        }

    }

    getClientGovDataByPhone(phone: string, cityId: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        ExternalDataStore.getInstance().clearClientGovDataByPhones()

        new RequestExecutorHelper()
            .get(
                self.getEndPoint(`/api/GovernmentServices/EGov/${phone}/${cityId}`),
                undefined,
                self.user.getAuthHeader()!)
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    response.json()
                        .then((data) => {
                            if (data['Error']) {
                                return
                            }
                            data = data['userInfoEGov']

                            const phoneData = new ExternalGovPhoneData()

                            phoneData.phone = data['phone']
                            phoneData.fullName = data['fullName']
                            phoneData.street = data['street']
                            phoneData.debt = data['debt']
                            phoneData.currentDebt = data['currentDebt']
                            phoneData.phoneFee = data['phoneFee']
                            phoneData.longDistantCallsFee = data['longDistantCallsFee']
                            phoneData.registrationOfCommunicationServices = data['registrationOfCommunicationServices']
                            phoneData.azDataCom = data['azDataCom']
                            phoneData.bakinterNet = data['bakinterNet']
                            ExternalDataStore.getInstance().pushClientGovDataByPhones(phoneData)
                        })
                        .catch((error) => {
                            self.processNotification('Get gov data by phone failed', 'danger', true)
                        })
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Get gov data by phone failed', 'danger', true)
            })
    }

    getClientGovDataByPin(pin: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        new RequestExecutorHelper()
            .get(
                self.getEndPoint('/api/GovernmentServices/C2B/') + pin,
                undefined,
                self.user.getAuthHeader()!)
            .then(response => {
                self.decReqNum()

                if (response['ok'] && 200 === response['status']) {
                    response.json()
                        .then((data) => {
                            if (data['Error']) {
                                return
                            }
                            data = data['userInfoC2B']

                            const pinData = new ExternalGovPinData()

                            pinData.pin = data['pin']
                            pinData.firstName = data['firstName']
                            pinData.middleName = data['middleName']
                            pinData.lastName = data['lastName']
                            pinData.dateOfBirth = data['dateOfBirth']
                            pinData.passportSeria = data['passportSeria']
                            pinData.passportGivenBy = data['passportGivenBy']
                            pinData.passportExpires = data['passportExpires']
                            pinData.city = data['city']
                            pinData.address = data['address']
                            ExternalDataStore.getInstance().setClientGovDataByPin(pinData)
                        })
                        .catch((error) => {
                            self.processNotification('Get gov data by pin failed', 'danger', true)
                        })
                }
            })
            .catch((error) => {
                self.decReqNum()
                self.processNotification('Get gov data by phone failed', 'danger', true)
            })
    }

    async getExternalDataByQuestionnaireId(qId: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        this.externalDataStore.setClientGovDataByPin(null)
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint('/api/Questionnaire/GetById/' + qId), undefined, self.user.getAuthHeader()!
            )

            let data = await response.json()
            self.questionnairesStore.setItem(data.questionnaire)

            let phones: Array<string> = data.questionnaire.client.phones.map((p: any) => { return p.number })

            this.getExternalDataByPhones(phones)

            // phones.forEach((pNumber) => {
            //     let cityIds = this.externalDataStore.getCities!.map(city => city['key'])

            //     cityIds.forEach(cituId =>
            //         this.getClientGovDataByPhone(pNumber, cituId)
            //     )
            // })

            self.decReqNum()
        } catch (error) {
            self.decReqNum()
            self.processNotification('Get External Data By questionnaireId failed!', 'danger', true)
        }
    }

    async getExternalDataByName(surname: string, name: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        this.externalDataStore.isError = false
        this.externalDataStore.setData(null)
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByName/' + surname + '/' + name),
                    undefined,
                    self.user.getAuthHeader()!)
            self.decReqNum()
            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()

                data.creditInfoItems.forEach(async (creditInfo: any) => {

                    if (!creditInfo) {
                        return
                    }

                    if (creditInfo.creditNumber) {
                        let responsePaymentSchedule = await new RequestExecutorHelper()
                            .get(
                                this.getExternalEndPoint(
                                    '/api/Payments/' + creditInfo.creditNumber + '/PaymentSchedule'
                                )
                            )
                        self.decReqNum()

                        if (response['ok'] && 200 === response['status']) {
                            let dataPaymentSchedule = await responsePaymentSchedule.json()
                            creditInfo.paymentSchedule = dataPaymentSchedule.paymentSchedule
                        }
                    }
                    this.externalDataStore.pushData(creditInfo)
                })
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
            }
        } catch (error) {
            self.decReqNum()
            this.externalDataStore.isError = true
            this.externalDataStore.setData(null)
            self.processNotification('Get External Data By Name fail!', 'danger', true)
        }
    }

    async getExternalDataByBDay(bDay: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        this.externalDataStore.isError = false
        this.externalDataStore.setData(null)
        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getExternalEndPoint('/api/CreditInfo/GetCreditInfoByBirthday/' + bDay),
                    undefined,
                    self.user.getAuthHeader()!)
            self.decReqNum()
            if (response['ok'] && 200 === response['status']) {
                let data = await response.json()

                data.creditInfoItems.forEach(async (creditInfo: any) => {

                    if (!creditInfo) {
                        return
                    }

                    if (creditInfo.creditNumber) {
                        let responsePaymentSchedule = await new RequestExecutorHelper()
                            .get(
                                this.getExternalEndPoint(
                                    '/api/Payments/' + creditInfo.creditNumber + '/PaymentSchedule'
                                )
                            )
                        self.decReqNum()

                        if (response['ok'] && 200 === response['status']) {
                            let dataPaymentSchedule = await responsePaymentSchedule.json()
                            creditInfo.paymentSchedule = dataPaymentSchedule.paymentSchedule
                        }
                    }
                    this.externalDataStore.pushData(creditInfo)
                })

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.externalDataStore.isError = true
                this.externalDataStore.setData(null)
            }
        } catch (error) {
            self.decReqNum()
            this.externalDataStore.isError = true
            this.externalDataStore.setData(null)
            self.processNotification('Get External Data By bDay fail!', 'danger', true)
        }
    }

    async getQuestionnaireByCreditNumAndSource(
        creditNumber: number,
        source: ExternalDataSourceType,
        amount: number,
        paymentStatus: PaymentStatus,
        paymentSource: PaymentSource,
        paymentDateTime: Date,
        paymentType: PaymentType,
        paymentDirection: PaymentDirection) {
        if (!this.user.checkSession) {
            history.push('/login')
        }
        const self = this

        self.incReqNum()

        try {

            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint(
                        `/api/Questionnaire/GetQuestionnaireByCreditNumberAndSource/${creditNumber}/${source}`),
                    undefined,
                    this.user.getAuthHeader()!
                )

            let data = await response.json()

            this.paymentsStore.setCreatePaymentQuestionnaireModel(
                new CreatePaymentQuestionnaireModel(
                    data.questionnaire,
                    new CreatePaymentRequest(
                        data.questionnaire['id'],
                        amount,
                        paymentStatus,
                        paymentSource,
                        paymentDateTime,
                        paymentType,
                        paymentDirection)))

            self.processNotification('Get questionnaire by credit number & source success!', 'success', true)
            self.decReqNum()
        } catch (ex) {
            this.paymentsStore.setCreatePaymentQuestionnaireModel(null)
            self.decReqNum()
            self.processNotification('Get questionnaire by credit number & source fail!', 'danger', true)
        }
    }

    updateCreatePaymentDescription(description: string) {
        this.paymentsStore.updateCreatePaymentDescription(description)
    }

    async getCurrentNotPaidPenalty(creditNumber: number) {
        // // if (!this.user.checkSession) {
        // //     history.push('/login')
        // // }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint('/api/Questionnaire/GetCurrentNotPaidPenaltyByCreditNumber/' + creditNumber),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            let data = await response.json()

            self.questionnairesStore.setCurrentNotPaidPenalty(data['amount'])
        } catch (error) {
            self.questionnairesStore.setCurrentNotPaidPenalty(0)
            self.decReqNum()
            self.processNotification('Get penalty by credit Id fail!', 'danger', true)
        }
    }

    // // async getGoogleChartsData() {
    // //     if (!this.user.checkSession) {
    // //         history.push('/login')
    // //     }

    // //     const self = this

    // //     self.incReqNum()

    // //     try {

    // //         let response = await
    // //             fetch(
    // //'https://script.google.com/macros/s/AKfycbxKfL4HQFbTmAadEbpc7lBp1cbUtIWUjvdBSL9BNy2EksdQePg/' +
    // //                 'exec?userId=' +
    // //                 this.user.id,
    // //             )

    // //         let data = await response.json()

    // //         // let result = data.schema.map((x: any, i: number) => {

    // //         //     if (i === 0) {
    // //         //         return ['status', 'count']
    // //         //     }

    // //         //     return [x, data.data[0][i]]
    // //         // })

    // //         self.decReqNum()
    // //     } catch (ex) {
    // //         self.decReqNum()
    // //     }
    // // }

///START SETTINGS

    async getAllSettings() {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint('/api/Settings'),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()
                self.settingsStore.set(data.settings)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Get Settings fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Settings fail!', 'danger', true)
        }
    }

    async createOrUpdateSetting(setting: Setting) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint('/api/Settings/CreateOrUpdate'),
                    JSON.stringify(setting),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                self.processNotification('Setting update success!', 'success', true)
                this.getAllSettings()
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Setting update fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Setting update fail!', 'danger', true)
        }
    }

    async deleteSetting(key: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .delete(
                    this.getEndPoint(`/api/Settings/${key}`),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                self.processNotification('Setting Delete success!', 'success', true)
                this.getAllSettings()
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Delete Settings fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Delete Settings fail!', 'danger', true)
        }
    }

    async clearSettingsCache(){
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint(`/api/Settings/ClearCache`),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                self.processNotification('Clear Setting Cache success!', 'success', true)
                this.getAllSettings()
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Clear Setting Cache fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Clear Setting Cache fail!', 'danger', true)
        }
    }

    ///END SETTINGS

    /// START AFFILIATES

    async getAffiliates() {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint('/api/Affiliate'),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.affiliatesStore.setList(data.affiliates)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Get Affiliates fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Affiliates fail!', 'danger', true)
        }
    }

    async getAffiliate(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        await this.getMerchants()

        if (!id) {
            self.affiliatesStore.setItem(new Affiliate())
            return
        }

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint(`/api/Affiliate/${id}`),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.affiliatesStore.setItem(data.affiliate)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.affiliatesStore.setItem(null)
                self.processNotification(`Get Affiliate fail!`, 'danger', true, ` id:${id}`)
            }
        } catch (error) {
            self.decReqNum()
            self.affiliatesStore.setItem(null)
            self.processNotification(`Get Affiliate fail!`, 'danger', true, ` id:${id}`)
        }
    }

    async updateAffiliate(affiliate: Affiliate) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .put(
                    this.getEndPoint(`/api/Affiliate`),
                    JSON.stringify({ affiliate: affiliate }),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.affiliatesStore.setItem(data.affiliate)
                self.processNotification(`Update Affiliate success!`, 'success', true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.affiliatesStore.setItem(null)
                self.processNotification(`Update Affiliate fail!`, 'danger', true)
            }

        } catch (error) {
            self.decReqNum()
            self.affiliatesStore.setItem(null)
            self.processNotification(`Update Affiliate fail!`, 'danger', true, `${error}`)
        }
    }

    async createAffiliate(affiliate: Affiliate) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint(`/api/Affiliate`),
                    JSON.stringify({ affiliate: affiliate }),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Create Affiliate success!`, 'success', true, `id: ${data.affiliateId}`)
                history.push('/affiliates')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else if (500 === response.status) {
                self.affiliatesStore.setItem(null)
                self.processNotification(`Create Affiliate fail! Perhaps affiliate already exists`, 'danger', true)
            } else {
                self.affiliatesStore.setItem(null)
                self.processNotification(`Create Affiliate fail!`, 'danger', true, `id: ${data.affiliateId}`)
            }

        } catch (error) {
            self.decReqNum()
            self.affiliatesStore.setItem(null)
            self.processNotification(`Create Affiliate fail!`, 'danger', true, `${error}`)
        }
    }

    /// END AFFILIATES

    /// START MERCHANTS

    async getMerchants() {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint('/api/Merchant'),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.merchantsStore.setList(data.merchants)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification('Get Merchants fail!', 'danger', true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Merchants fail!', 'danger', true)
        }
    }

    async getMerchant(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        if (!id) {
            self.merchantsStore.setItem(new Merchant())
            return
        }

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .get(
                    this.getEndPoint(`/api/Merchant/${id}`),
                    undefined,
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.merchantsStore.setItem(data.merchant)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.merchantsStore.setItem(null)
                self.processNotification(`Get Merchant fail!`, 'danger', true, `by id ${id}`)
            }
        } catch (error) {
            self.decReqNum()
            self.merchantsStore.setItem(null)
            self.processNotification(`Get Merchant fail!`, 'danger', true, `by id ${id}`)
        }
    }

    async updateMerchant(merchant: Merchant) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .put(
                    this.getEndPoint(`/api/Merchant`),
                    JSON.stringify({ merchant: merchant }),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.merchantsStore.setItem(data.merchant)
                self.processNotification(`Update Merchant success!`, 'success', true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.merchantsStore.setItem(null)
                self.processNotification(`Update Merchant fail!`, 'danger', true)
            }

        } catch (error) {
            self.decReqNum()
            self.merchantsStore.setItem(null)
            self.processNotification('Update Merchant fail!', 'danger', true)
        }
    }

    async createMerchant(merchant: Merchant) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint(`/api/Merchant`),
                    JSON.stringify({ merchant: merchant }),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Create Merchant success!`, 'success', true, ` id: ${data.merchantId}`)
                history.push('/merchants')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else if (500 === response.status) {
                self.merchantsStore.setItem(null)
                self.processNotification(`Create Merchant fail! Perhaps Merchant already exists`, 'danger', true)
            } else {
                self.merchantsStore.setItem(null)
                self.processNotification(`Create Merchant fail!`, 'danger', true, ` id: ${data.merchantId}`)
            }

        } catch (error) {
            self.decReqNum()
            self.merchantsStore.setItem(null)
            self.processNotification('fail!', 'danger', true, `${error}`)
        }
    }

    /// END MERCHANTS

    /// Payments

    public async getPayments(
        page: number,
        pageSize: number,
        filter: any,
        sort: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/Payment/GetPayments'),
                JSON.stringify(new PaginationRequest(page, pageSize, filter, sort)),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Payments success!`, 'success', true)
                self.paymentsStore.setList(data.payments)
                this.paymentsStore
                    .setPageCountAll(data.pageCount)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Payments fail!`, 'danger', true)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Payments fail!', 'danger', true)
        }
    }

    public async getPayment(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint(`/api/Payment/GetPayment/${id}`),
                undefined,
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Payment success!`, 'success', true, ` id: ${id}`)
                self.paymentsStore.setItem(data.payment)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Payment fail!`, 'danger', true, ` id: ${id}`)
                self.paymentsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(`Get Payment fail!`, 'danger', true, ` id: ${id}`)
            self.paymentsStore.setItem(null)

        }
    }

    @action.bound
    public clearPayment() {
        this.paymentsStore.setItem(null)
    }

    async createPayment(payment: CreatePaymentRequest) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        if (!payment || !payment.questionnaireId || payment.amount < 0) {
            self.processNotification('Payment create fail!', 'danger', true)
        }

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint('/api/Payment/CreatePayment'),
                    JSON.stringify(payment),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()

                this.paymentsStore.setItem(data.payment)
                self.processNotification('Payment create success!', 'success', true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.paymentsStore.setItem(null)
                history.push('/payments')
                self.processNotification(
                    `Payment create fail!`,
                    'danger',
                    true,
                    `${JSON.stringify(payment)} ${JSON.stringify(await response.json())}`)
            }
        } catch (error) {
            this.paymentsStore.setItem(null)
            self.decReqNum()
            self.processNotification(
                `Payment create fail! `,
                'danger',
                true,
                `${JSON.stringify(payment)} ${JSON.stringify(error)}`)
            history.push('/payments')
        }
    }

    @action.bound
    public async updatePaymentStatus(request: UpdatePaymentStatusRequest) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().put(
                self.getEndPoint(`/api/Payment/UpdatePaymentStatus`),
                JSON.stringify(request),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(
                    `Update Payment Status success!`,
                    'success',
                    true,
                    `id: ${request.id} 
                    status: ${getPaymentStatusText(request.paymentStatus)}`)
                self.paymentsStore.setItem(data.payment)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    `Update Payment Status fail!`,
                    'danger',
                    true,
                    `id: ${request.id}
                    status: ${getPaymentStatusText(request.paymentStatus)}`
                )
                self.paymentsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(
                `Update Payment Status fail!`,
                'danger',
                true,
                `id: ${request.id}
                status: ${getPaymentStatusText(request.paymentStatus)}`)
            self.paymentsStore.setItem(null)

        }
    }

    /// END Payments

    /// START Catalog Products

    public async getCatalogProducts(
        page: number,
        pageSize: number,
        filter: any,
        sort: any) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint('/api/CatalogProduct/GetCatalogProducts'),
                JSON.stringify(new PaginationRequest(page, pageSize, filter, sort)),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Catalog Products success!`, 'success', true)
                self.catalogProductsStore.setList(data.products)
                this.catalogProductsStore
                    .setPageCountAll(data.pageCount)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Catalog Products fail!`, 'danger', true)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification('Get Catalog Products fail!', 'danger', true)
        }
    }

    public async getCatalogProduct(id: string) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        if (!id) {
            self.catalogProductsStore.setItem(new CatalogProduct())
            return
        }

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint(`/api/CatalogProduct/${id}`),
                undefined,
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Catalog Product success!`, 'success', true, ` id: ${id}`)
                self.catalogProductsStore.setItem(data.product)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Catalog Product fail!`, 'danger', true, ` id: ${id}`)
                self.catalogProductsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(`Get Catalog Product fail!`, 'danger', true, ` id: ${id}`)
            self.catalogProductsStore.setItem(null)

        }
    }

    @action.bound
    public clearCatalogProduct() {
        this.catalogProductsStore.setItem(null)
    }

    async createCatalogProduct(catalogProduct: CatalogProduct) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper()
                .post(
                    this.getEndPoint('/api/CatalogProduct'),
                    JSON.stringify({ product: catalogProduct }),
                    self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                let data = await response.json()

                this.catalogProductsStore.setItem(data.product)
                self.processNotification('Catalog Product create success!', 'success', true)
                history.push('/catalogProducts')
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                this.catalogProductsStore.setItem(null)
                self.processNotification('Catalog Product create fail!', 'danger', true)
            }
        } catch (error) {
            this.catalogProductsStore.setItem(null)
            self.decReqNum()
            self.processNotification('Catalog Product create fail!', 'danger', true)
        }
    }

    @action.bound
    public async updateCatalogProduct(catalogProduct: CatalogProduct) {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().put(
                self.getEndPoint(`/api/CatalogProduct`),
                JSON.stringify({ product: catalogProduct }),
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(
                    `Update Catalog Product success!`,
                    'success',
                    true,
                    `id: ${catalogProduct.id}`)
                self.catalogProductsStore.setItem(data.product)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    `Update Catalog Product fail!`,
                    'danger',
                    true,
                    `id: ${catalogProduct.id}`)
                self.catalogProductsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(
                `Update Catalog Product fail!`,
                'danger',
                true,
                `id: ${catalogProduct.id}`)
            self.catalogProductsStore.setItem(null)
        }
    }

    /// END Catalog Products

    /// PROXY CACHE

    public async clearProxyCache() {
        if (!this.user.checkSession) {
            history.push('/login')
        }

        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().post(
                self.getEndPoint(`/api/ProxyCache/ClearProxyCache`),
                null,
                self.user.getAuthHeader()!)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                self.processNotification(
                    `Clear Proxy Cache success!`,
                    'success',
                    true)
            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(
                    `Clear Proxy Cache fail!`,
                    'danger',
                    true)
            }
        } catch (error) {
            self.decReqNum()
            self.processNotification(
                `Clear Proxy Cache fail!`,
                'danger',
                true)
        }
    }

    /// END PROXY CACHE

    /// START CREDIT

    public async getCreditByNumber(creditNumber: number) {
        const self = this

        if (!creditNumber) {
            self.creditsStore.setItem(null)
            return
        }

        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint(`/api/Credit/GetCreditByNumber/${creditNumber}`),
                undefined,
                undefined)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Credit By Number success!`, 'success', true, ` number: ${creditNumber}`)

                // await this.getCurrentNotPaidPenalty(data.credit.creditNumber)

                self.creditsStore.setItem(data.credit)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Credit By Number fail!`, 'danger', true, ` number: ${creditNumber}`)
                self.creditsStore.setItem(null)
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(`Get Credit By Number fail!`, 'danger', true, ` number: ${creditNumber}`)
            self.creditsStore.setItem(null)
        }
    }

    /// END CREDIT

    /// START ScheduleConfiguration

    public async getScheduleConfiguration(){
        const self = this
        self.incReqNum()

        try {
            let response = await new RequestExecutorHelper().get(
                self.getEndPoint(`/api/Questionnaire/GetScheduleConfiguration/`),
                undefined,
                undefined)

            self.decReqNum()

            if (response['ok'] && 200 === response.status) {
                var data = await response.json()
                self.processNotification(`Get Schedule Configuration success!`, 'success', true)

                self.scheduleConfigurationStore.set(data)

            } else if (-1 !== [403, 404, 0].indexOf(response.status)) {
                history.push('/login')
            } else {
                self.processNotification(`Get Schedule Configuration fail!`, 'danger', true)
                self.scheduleConfigurationStore.set([new ScheduleConfig()])
            }

        } catch (error) {
            self.decReqNum()
            self.processNotification(`Get Schedule Configuration fail!`, 'danger', true)
            self.scheduleConfigurationStore.set([new ScheduleConfig()])
        }
    }

    /// END ScheduleConfiguration
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Services/HttpActionsService.ts